import { ICONS } from '../../constants/icons';
import hreflangs from '../_hreflang/index';
import sortHreflangs from '../_hreflang/sortHrefLangs';

export default {
  hrefLang: sortHreflangs(hreflangs, 'pl'),
  schema: {
    siteName: {
      name: 'Natu.Care',
      url: 'https://natu.care/pl',
      potentialAction: {
        target: 'https://shop.natu.care/search?q={search_term_string}',
        queryInput: 'required name=search_term_string'
      }
    }
  },




  hero: [   
    {
      actions: {
        picture: {
          href: 'https://shop.natu.care/collections'
        }
      },
      picture: {
        xs: {
          avif: '/images/natu-care-vogue-beauty-awards-375.avif',
          webp: '/images/natu-care-vogue-beauty-awards-375.webp',
          src: '/images/natu-care-vogue-beauty-awards-375.webp',
        },
        sm: {
          avif: '/images/natu-care-vogue-beauty-awards-1024.avif',
          webp: '/images/natu-care-vogue-beauty-awards-1024.webp',
        },
        md: {
          avif: '/images/natu-care-vogue-beauty-awards-1440.avif',
          webp: '/images/natu-care-vogue-beauty-awards-1440.webp',
        },
        lg: {
          avif: '/images/natu-care-vogue-beauty-awards-1920.avif',
          webp: '/images/natu-care-vogue-beauty-awards-1920.webp',
        }
      }
    },    
    {
      actions: {
        picture: {
          href: 'https://shop.natu.care/products/collagen-glow-bar-baton-toffi'
        }
      },
      picture: {
        xs: {
          avif: '/images/collagen-glow-bar-375.avif',
          webp: '/images/collagen-glow-bar-375.webp',
          src: '/images/collagen-glow-bar-375.webp',
        },
        sm: {
          avif: '/images/collagen-glow-bar-1024.avif',
          webp: '/images/collagen-glow-bar-1024.webp',
        },
        md: {
          avif: '/images/collagen-glow-bar-1440.avif',
          webp: '/images/collagen-glow-bar-1440.webp',
        },
        lg: {
          avif: '/images/collagen-glow-bar-1920.avif',
          webp: '/images/collagen-glow-bar-1920.webp',
        }
      }
    },    
    {
      actions: {
        picture: {
          href: 'https://shop.natu.care/products/slim-boost'
        }
      },
      picture: {
        xs: {
          avif: '/images/slim-boost-480.avif',
          webp: '/images/slim-boost-480.webp',
          src: '/images/slim-boost-480.webp',
        },
        sm: {
          avif: '/images/slim-boost-1024.avif',
          webp: '/images/slim-boost-1024.webp',
        },
        md: {
          avif: '/images/slim-boost-1440.avif',
          webp: '/images/slim-boost-1440.webp',
        },
        lg: {
          avif: '/images/slim-boost-1920.avif',
          webp: '/images/slim-boost-1920.webp',
        }
      }
    },         
    {
      actions: {
        picture: {
          href: 'https://shop.natu.care/collections#kolagen-premium'
        }
      },
      picture: {
        xs: {
          avif: '/images/piekno-zaczyna-sie-od-zdrowia-480.avif',
          webp: '/images/piekno-zaczyna-sie-od-zdrowia-480.webp',
          src: '/images/piekno-zaczyna-sie-od-zdrowia-480.webp',
        },
        sm: {
          avif: '/images/piekno-zaczyna-sie-od-zdrowia-1024.avif',
          webp: '/images/piekno-zaczyna-sie-od-zdrowia-1024.webp',
        },
        md: {
          avif: '/images/piekno-zaczyna-sie-od-zdrowia-1440.avif',
          webp: '/images/piekno-zaczyna-sie-od-zdrowia-1440.webp',
        },
        lg: {
          avif: '/images/piekno-zaczyna-sie-od-zdrowia-1920.avif',
          webp: '/images/piekno-zaczyna-sie-od-zdrowia-1920.webp',
        }
      }
    }
  ],
  mediabar: {
    href: '/pl/o-nas',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }
    ]
  },
  productHighlight: {
    subheading: 'POZNAJ NASZ BESTSELLER',
    heading: 'Kolagen premium 5000mg',
    cols: [
      {
        items: [
          {
            heading: 'Bez rybiego posmaku',
            text: 'Wyczujesz jedynie naturalny smak świeżych owoców lub prawdziwego kakao',
            icon: {
              path: '<path fill="#fff" d="M0 .142h56v56H0z"/><g clip-path="url(#clip0_17783_51313)"><path stroke="#EE943F" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.05" d="M22.924 38.991c0 1.574.337 6.958-3.517 8.297-1.846.647-7.223 1.912-11.092 4.898M14.557 19.81c-.015 1.676-.66 8.649 2.197 13.18 2.33 3.707 7.415 6.56 9.861 7.782a3.22 3.22 0 0 0 2.8.029c2.505-1.192 7.662-3.987 9.846-7.811 1.45-2.663 2.9-7.267 2.9-8.459"/><path stroke="#EE943F" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.05" d="M12.051 21.75c-.029 2.707 1.275 4.149 2.389 4.149M44.58 21.75c.029 2.707-1.275 4.149-2.389 4.149M33.078 38.991c0 1.574-.337 6.958 3.516 8.297 1.89.662 7.21 1.765 11.092 4.898M32.711 15.543v-2.34m1.392-6.78v-2.34m1.172 1.177h-2.33m.938 9.12h-2.33M31.539 9.1c-2.11 0-3.59 2.119-3.59 3.545 0-1.441-1.494-3.545-3.59-3.545 2.11 0 3.59-2.118 3.59-3.545 0 1.442 1.495 3.545 3.59 3.545ZM27.158 34.401c.528.22 1.055.22 1.568 0"/><path fill="#EE943F" d="M18.455 20.72c1.245-.117 2.388.59 3.546.722 1.084.088 2.285-.06 3.384-.31.132-.043.293.045.323.177.029.103-.03.206-.118.265-1.142.647-2.403.868-3.707.706-1.333-.206-2.315-.985-3.428-1.133-.264-.014-.264-.426 0-.44v.014ZM38.089 21.162c-1.1.132-2.096.927-3.43 1.133-1.303.161-2.578-.06-3.706-.706-.235-.133-.073-.515.176-.456 1.729.397 3.414.53 5.07-.133.57-.191 1.23-.353 1.875-.294.117 0 .205.118.205.25 0 .103-.103.191-.205.206h.015ZM18.66 15.5c.424-.28 5.406.529 3.912 1.044-1.114-.339-2.623-.427-3.737-.177-.586.162-.776-.794-.175-.868ZM31.628 32.651c-1.026.162-1.847-.132-2.652.162-.206.088-.47.426-1.04.456-.983-.133-.865-.633-1.744-.588-.616-.045-1.143.058-1.934-.089a.318.318 0 0 1-.264-.368c.03-.205.234-.28.41-.28.791 0 2.08-.337 2.916.09.732.47.498.47 1.23 0 .968-.471 2.14-.09 3.019-.163.469-.029.513.692.059.736v.044Z"/><path stroke="#EE943F" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.05" d="M26.895 27.811c.615.515 1.055.5 1.743-.044"/></g><defs><clipPath id="clip0_17783_51313"><path fill="#fff" d="M7.875 3.642h40.25v49H7.875z"/></clipPath></defs>',
              viewBox: '0 0 56 57'
            }
          },
          {
            heading: '100% naturalny',
            text: 'Bez sztucznych dodatków, konserwantów, GMO, laktozy i cukru',
            icon: {
              path: '<path stroke="#EE943F" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.05" d="M8.168 32.442c0 9.788 7.935 17.723 17.723 17.723s17.699-8.032 17.699-17.82c0-3.266-.926-6.098-2.391-8.517M19.028 13.479c.57-.401 2.064-.92 4.154-.92.556 0 1.345.115 2.294.349m-2.294-2.77 2.294 2.77m0 0c1.452.357 3.275.993 5.203 1.923m0 0-2.27 2.543m2.27-2.543c3.785 1.826 7.97 4.786 10.52 8.997m-26.424-1.11c1.91 1.47 2.387 2.18 4.116 2.18 1.886 0 2.903-1.495 5.133-1.495s3.548 1.985 5.94 1.985c2.394 0 2.014-2.025.411-4.21m-18.333 5.936c3.237.113 7.424.724 7.424 2.308 0 1.59-4.079 2.96-4.163 5.774 0 2.875 2.601 4.276-.25 7.354m23.251-18.2c-1.005 1.384-1.452 2.1-3.485 2.764-1.899.62.648 6.886-1.899 6.886-2.554.246-10.545-.648-10.545 3.977 0 3.977 6.993 0 6.993 2.234 0 1.43-3.083 3.329-5.786 6.836M44.993 13.48c-1.089 2.14-3.663 7.189-3.794 10.349m-21.316-4.943c-5.194 2.306-8.817 7.508-8.817 13.557 0 8.188 6.638 14.826 14.826 14.826s14.825-6.638 14.825-14.826c0-5.527-3.025-10.349-7.51-12.898M47.831 8.97c-2.95.658-7.83 3.767-7.83 7.784 0 1.475.319 4.107 4.04 4.107 5.106 0 2.995-10.12 3.79-11.89Zm-35.494 6.791c2.22-3.681 7.48-9.642 14.346-9.642s8.765 5.035 8.765 8.298-2.527 7.29-8.575 7.29c-7.1 0-9.57-7.728-14.536-5.946Z"/>',
              viewBox: '0 0 56 57'
            }
          },
          {
            heading: 'Bezpieczny i przebadany',
            text: 'Posiada certyfikat niezależnego laboratorium J.S Hamilton',
            icon: {
              path: '<path stroke="#EE943F" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.05" d="M46.92 45.198h-4.834m-8.798-27.076v-6.618H8.262v33.694h33.825m0 0c2.28-3.112 5.348-6.284 5.348-12.858 0-5.235-3.445-9.465-4.72-11.096m-30.803-1.955 2.058 2.059 3.74-4.598m-5.798 11.794 2.058 2.058 3.74-4.598M11.913 37.35l2.058 2.06 3.74-4.599m16.111-4.572-6.3-6.19L41.44 9.885l6.3 6.19-5.07 5.16-.529.538m-8.319 8.465 4.854-4.94m-4.853 4.94v9.323M44.871 9.6l2.669 2.569m-6.675 13.778a2.468 2.468 0 1 0-.95-4.845 2.468 2.468 0 0 0 .95 4.845Zm0 0v6.477c0 3.585-2.335 7.1-6.321 7.1H25.06c-1.829 0-3.402.753-3.402 3.073v2.576M17.5 47.684h29.297"/>',
              viewBox: '0 0 56 57'
            }
          }
        ]
      },
      {
        items: [
          {
            heading: 'Szybkie i łatwe przygotowanie',
            text: 'Wsyp saszetkę naszego kolagenu do wody, zamieszaj i gotowe!',
            icon: {
              path: '<g clip-path="url(#clip0_17783_51665)"><g stroke="#EE943F" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.05" clip-path="url(#clip1_17783_51665)"><path d="m13.45 17.063 5.27 34.28M39.4 37.655l3.154-20.592M37.297 51.344l1.584-10.311M37.295 51.091c0 1.34-4.16 2.44-9.298 2.44-5.137 0-9.298-1.086-9.298-2.44M41.781 34.501c1.718.387 2.724.863 2.724 1.354 0 1.34-7.15 2.44-15.96 2.44S12.6 37.21 12.6 35.87c0-.58 1.303-1.1 3.479-1.517M43.13 39.798c-2.324.908-8.098 1.548-14.864 1.548M28 19.325c8.053 0 14.583-1.092 14.583-2.44 0-1.348-6.53-2.44-14.584-2.44-8.054 0-14.583 1.092-14.583 2.44 0 1.348 6.53 2.44 14.583 2.44ZM14.896 24.667c3.287 0 3.287 2.618 6.574 2.618s3.287-2.618 6.574-2.618 3.287 2.618 6.573 2.618c3.287 0 3.287-2.618 6.574-2.618M31.003 6.99c-1.969 0-3.375 1.98-3.375 3.333 0-1.339-1.392-3.332-3.376-3.332 1.97 0 3.376-1.98 3.376-3.333 0 1.339 1.391 3.333 3.375 3.333ZM46.714 28.952c-1.259 0-2.162 1.265-2.162 2.128 0-.863-.888-2.128-2.161-2.128 1.258 0 2.161-1.265 2.161-2.128 0 .863.889 2.128 2.162 2.128ZM19.883 10.323V7.958m1.184 1.19h-2.354"/></g></g><defs><clipPath id="clip0_17783_51665"><path fill="#fff" d="M0 .858h56v56H0z"/></clipPath><clipPath id="clip1_17783_51665"><path fill="#fff" d="M12.502 3.483h35v50.75h-35z"/></clipPath></defs>',
              viewBox: '0 0 56 57'
            }
          },
          {
            heading: 'Topowi dostawcy surowców',
            text: 'Współpracujemy jedynie z najlepszymi, zaufanymi dostawcami surowców',
            icon: {
              path: '<path fill="#EE943F" d="M18.458 43.716a.525.525 0 1 0 0-1.05v1.05Zm21.084-1.05a.525.525 0 1 0 0 1.05v-1.05Zm-10.5-1.392.37.371a.525.525 0 0 0-.376-.896l.005.525Zm-11.542.698-.37-.37a.525.525 0 0 0 0 .742l.37-.372Zm6.159-5.416a.525.525 0 0 0-.743-.742l.743.742Zm-.737 10.838-.372.37a.525.525 0 0 0 .743 0l-.371-.37Zm17.619-5.422.37.372a.525.525 0 0 0 0-.743l-.37.371Zm-5.416-6.158a.525.525 0 1 0-.743.742l.743-.742Zm-.005 11.58-.372.37a.525.525 0 0 0 .743 0l-.371-.37ZM23.25 15.833a.525.525 0 0 0 0 1.05v-1.05Zm11.5 1.05a.525.525 0 1 0 0-1.05v1.05ZM19.417 22.54a.525.525 0 1 0 0 1.05v-1.05Zm19.166 1.05a.525.525 0 1 0 0-1.05v1.05Zm-23-14.375h26.834v-1.05H15.583v1.05Zm30.142 3.309v26.833h1.05V12.525h-1.05Zm-33.45 26.833V12.525h-1.05v26.833h1.05Zm3.308 3.308a3.308 3.308 0 0 1-3.308-3.308h-1.05a4.358 4.358 0 0 0 4.358 4.358v-1.05Zm30.142-3.308a3.308 3.308 0 0 1-3.308 3.308v1.05a4.358 4.358 0 0 0 4.358-4.358h-1.05ZM42.417 9.216a3.308 3.308 0 0 1 3.308 3.309h1.05a4.358 4.358 0 0 0-4.358-4.359v1.05Zm-26.834-1.05a4.358 4.358 0 0 0-4.358 4.358h1.05a3.308 3.308 0 0 1 3.308-3.308v-1.05Zm2.875 34.5h-2.875v1.05h2.875v-1.05Zm23.959 0h-2.875v1.05h2.875v-1.05Zm-8.192-7.141A5.225 5.225 0 0 1 29 40.749v1.05a6.275 6.275 0 0 0 6.275-6.274h-1.05ZM29 40.749a5.225 5.225 0 0 1-5.225-5.224h-1.05A6.275 6.275 0 0 0 29 41.8v-1.05Zm-5.225-5.224A5.225 5.225 0 0 1 29 30.299v-1.05a6.275 6.275 0 0 0-6.275 6.276h1.05ZM29 30.299a5.225 5.225 0 0 1 5.225 5.226h1.05A6.275 6.275 0 0 0 29 29.25v1.05Zm.005 11.5h.041l-.01-1.05h-.041l.01 1.05Zm-11.133.545 5.787-5.788-.743-.742-5.787 5.787.743.743Zm5.42 4.678-5.42-5.42-.743.742 5.421 5.42.743-.742Zm5.378-6.12-6.12 6.12.743.743 6.12-6.12-.743-.742Zm12.242.7-5.787-5.788-.743.742 5.788 5.788.742-.743Zm-5.421 6.163 5.42-5.421-.742-.743-5.42 5.421.742.743Zm-6.862-6.12 6.12 6.12.742-.743-6.12-6.119-.742.743ZM23.25 16.884h11.5v-1.05h-11.5v1.05Zm-3.833 6.708h19.166v-1.05H19.417v1.05Z"/>',
              viewBox: '0 0 56 57'
            }
          },
          {
            heading: 'Zrównoważona produkcja',
            text: 'To dla nas naprawdę ważne! Dbamy o naszą planatę na każdym etapie produkcji',
            icon: {
              path: '<path stroke="#EE943F" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.05" d="M6.112 41.288h4.242c0-2.616 2.806-4.603 4.488-4.603 3.371 0 8.305 1.987 10.751 1.987 1.58 0 4.663.153 6.344.153 2.242 0 3.134 2.395 3.134 4.586m0 0H24.6m10.47 0c2.997-2.405 8.026-6.607 10.166-8.407 1.548-1.302 4.663-.433 4.663 2.593 0 1.228-.958 1.882-1.437 2.438l-9.243 9.096c-1.194 1.145-4.483 3.812-9.014 3.812-2.88 0-12.172-2.47-15.46-2.47H6.32m21.908-19.454c7.367 0 13.339-5.972 13.339-13.339S35.595 4.341 28.227 4.341c-7.366 0-13.338 5.972-13.338 13.34m13.339 13.338c-7.367 0-13.34-5.972-13.34-13.339m13.34 13.34c0-6.297-2.324-14.542-13.34-13.34m13.34 13.34c0-6.297 2.323-14.542 13.338-13.34m-8.5 1.465c.613-3.831-1.645-7.387-4.924-9.563-3.28 2.176-5.549 5.732-4.936 9.563"/>',
              viewBox: '0 0 56 57'
            }
          }
        ]

      }
    ],
    buttons: [
      {
        label: 'Odkryj kolageny',
        href: 'https://shop.natu.care/collections#kolagen-premium'
      },
      {
        label: 'Jaki kolagen wybrać?',
        href: 'https://shop.natu.care/pages/wybierz-kolagen'
      }
    ]
  },
  productCollectionsLinks:
  {
    heading: 'Odkryj suplementy Natu.Care',
    tabs: [
      {
        label: 'Poznaj produkty',

        items: [
          {
            picture: {
              xs: {
                src: '/images/odkryj-suplementacje-nowosci.jpg'
              },
              alt: 'Nowości'
            },
            heading: 'Nowości',
            href: 'https://shop.natu.care/collections#nowosci'
          },
          {
            picture: {
              xs: {
                src: '/images/odkryj-suplementacje-kolagen-premium.jpg'
              },
              alt: 'Kolagen premium'
            },
            heading: 'Kolagen premium',
            href: 'https://shop.natu.care/collections#kolagen-premium'
          },
          {
            picture: {
              xs: {
                src: '/images/odkryj-suplementacje-kwasy-omega-3.jpg'
              },
              alt: 'Kwasy Omega-3'
            },
            heading: 'Kwasy Omega-3 ',
            href: 'https://shop.natu.care/collections#kwasy-omega-3'
          },
          {
            picture: {
              xs: {
                src: '/images/odkryj-suplementacje-maslan-sodu.jpg'
              },
              alt: 'Maślan sodu'
            },
            heading: 'Maślan sodu',
            href: 'https://shop.natu.care/collections#maslan-sodu'
          },
          {
            picture: {
              xs: {
                src: '/images/ksztaltowanie-sylwetki.png'
              },
              alt: 'Kształtowanie sylewtki'
            },
            heading: ' Kształtowanie sylwetki',
            href: 'https://shop.natu.care/collections#ksztaltowanie-sylwetki'
          }, 
          {
            picture: {
              xs: {
                src: '/images/odkryj-suplementacje-colostrum.jpg'
              },
              alt: 'Colostrum'
            },
            heading: 'Colostrum',
            href: 'https://shop.natu.care/collections#colostrum'
          },
          {
            picture: {
              xs: {
                src: '/images/odkryj-suplementacje-adaptogeny.jpg'
              },
              alt: 'Adaptogeny'
            },
            heading: 'Adaptogeny',
            href: 'https://shop.natu.care/collections#adaptogeny'
          },
          {
            picture: {
              xs: {
                src: '/images/odkryj-suplementacje-uzupelnij-suplementacje.jpg'
              },
              alt: 'Uzupełnij suplementację'
            },
            heading: 'Uzupełnij suplementację',
            href: 'https://shop.natu.care/collections#wzmocnij-suplementacje'
          }
        ]
      },
      {
        label: 'Wybierz swój cel',
        items: [
          {
            picture: {
              xs: {
                src: '/images/wybierz-swoj-cel-skora-wlosy-paznokcie.png'
              },
              alt: 'Skóra, włosy i paznokcie'
            },
            heading: 'Skóra, włosy i paznokcie',
            href: 'https://shop.natu.care/collections#skora-wlosy-i-paznokcie'
          },
          {
            picture: {
              xs: {
                src: '/images/ksztaltowanie-sylwetki.png'
              },
              alt: 'Kształtowanie sylewtki'
            },
            heading: ' Kształtowanie sylwetki',
            href: 'https://shop.natu.care/collections#ksztaltowanie-sylwetki-cel'
          },
          {
            picture: {
              xs: {
                src: '/images/wybierz-swoj-cel-samopoczucie-sen-i-stres.png'
              },
              alt: 'Samopoczucie, sen i stres'
            },
            heading: 'Samopoczucie, sen i stres',
            href: 'https://shop.natu.care/collections#samopoczucie-sen-i-stres'
          },
          {
            picture: {
              xs: {
                src: '/images/wybierz-swoj-cel-odpornosc.png'
              },
              alt: 'Odporność'
            },
            heading: 'Odporność',
            href: 'https://shop.natu.care/collections#odpornosc'
          }
        ]
      }
    ]
  },
  infoSectionCalculator: {
    heading: 'Jaki kolagen wybrać?',
    text: 'Rozwiąż quiz, poznaj odpowiedź',
    actions: {
      button: {
        label: 'Kliknij, by rozpocząć',
        href: 'https://shop.natu.care/pages/wybierz-kolagen'
      }
    }
  },
  featureContent: [
    {
      subheading: 'Badania',
      heading: 'Jakość i bezpieczeństwo',
      list: [
        {
          icon: {
            path: '<path stroke="#525252" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M53.623 51.707h-5.524M38.044 20.763V13.2H9.442v38.508H48.1m0 0c2.607-3.557 6.112-7.182 6.112-14.696 0-5.982-3.936-10.816-5.393-12.68m-35.204-2.234 2.352 2.353 4.275-5.255m-6.627 13.478 2.352 2.353 4.275-5.255m-6.627 12.966 2.352 2.353 4.275-5.255m18.413-5.225-7.2-7.075 15.905-16.186 7.2 7.075-5.795 5.897-.604.614m-9.506 9.675 5.547-5.645m-5.547 5.645v10.654m12.628-34.241 3.05 2.936m-7.628 15.746a2.821 2.821 0 1 0-1.085-5.536 2.821 2.821 0 0 0 1.085 5.536Zm0 0v7.403c0 4.097-2.668 8.114-7.224 8.114H28.642c-2.09 0-3.888.86-3.888 3.512v2.944M20 54.548h33.481"/>',
            viewBox: '0 0 64 65'
          },
          text: 'Każdy z naszych produktów posiada certyfikat niezależnego, akredytowanego laboratorium J.S. Hamilton Poland.'
        },
        {
          icon: {
            path: '<path stroke="#525252" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M9.335 37.7c0 11.186 9.068 20.255 20.255 20.255 11.186 0 20.227-9.18 20.227-20.366 0-3.733-1.058-6.97-2.732-9.734m-25.34-11.827c.654-.459 2.36-1.052 4.748-1.052.636 0 1.539.131 2.623.399m-2.622-3.165 2.622 3.165m0 0c1.659.408 3.743 1.135 5.945 2.198m0 0-2.594 2.906m2.594-2.906c4.326 2.087 9.11 5.47 12.024 10.282m-30.2-1.27c2.185 1.68 2.729 2.493 4.705 2.493 2.156 0 3.318-1.708 5.866-1.708 2.548 0 4.055 2.268 6.79 2.268 2.734 0 2.3-2.314.469-4.81M13.763 31.61c3.699.13 8.484.828 8.484 2.639 0 1.817-4.662 3.382-4.758 6.598 0 3.286 2.973 4.887-.286 8.405m26.573-20.801c-1.148 1.583-1.66 2.4-3.983 3.16-2.17.709.74 7.87-2.17 7.87-2.92.28-12.051-.74-12.051 4.544 0 4.545 7.992 0 7.992 2.554 0 1.634-3.524 3.804-6.613 7.812m24.47-38.363c-1.245 2.446-4.187 8.215-4.336 11.827m-24.361-5.649c-5.936 2.635-10.076 8.581-10.076 15.494 0 9.358 7.585 16.944 16.943 16.944 9.357 0 16.943-7.586 16.943-16.944 0-6.318-3.457-11.828-8.584-14.74m16.715-12.085c-3.371.752-8.947 4.305-8.947 8.895 0 1.686.363 4.694 4.616 4.694 5.835 0 3.423-11.566 4.33-13.59ZM14.1 18.635c2.537-4.207 8.548-11.018 16.395-11.018 7.847 0 10.017 5.754 10.017 9.483 0 3.73-2.888 8.33-9.8 8.33-8.114 0-10.936-8.831-16.612-6.794Z"/>',
            viewBox: '0 0 64 65'
          },
          text: 'Nasze kolageny pozyskiwane są ze sprawdzonych i zrównoważonych źródeł.'
        },
        {
          icon: {
            path: '<path stroke="#525252" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M6.985 47.239h4.848c0-2.99 3.207-5.261 5.129-5.261 3.853 0 9.492 2.27 12.287 2.27 1.806 0 5.329.176 7.25.176 2.563 0 3.582 2.737 3.582 5.24m0 0H28.114m11.967 0c3.424-2.748 9.172-7.55 11.617-9.608 1.77-1.488 5.329-.494 5.329 2.965 0 1.403-1.095 2.15-1.642 2.785L44.822 56.202c-1.365 1.308-5.123 4.356-10.302 4.356-3.29 0-13.91-2.823-17.669-2.823H7.223M32.26 35.502c8.42 0 15.245-6.825 15.245-15.244 0-8.42-6.826-15.245-15.245-15.245-8.42 0-15.244 6.826-15.244 15.245M32.26 35.502c-8.42 0-15.244-6.825-15.244-15.244M32.26 35.502c0-7.196-2.656-16.618-15.244-15.244m15.243 15.244c0-7.196 2.656-16.618 15.245-15.244m-9.715 1.674c.7-4.379-1.879-8.442-5.627-10.929-3.748 2.487-6.341 6.55-5.64 10.929"/>',
            viewBox: '0 0 64 65'
          },
          text: 'Surowce wykorzystywane w naszych produktach pochodzą jedynie od sprawdzonych dostawców, a każdy etap produkcji jest przez nas bezwględnie nadzorowany.'
        }
      ],
      variant: [
        'White2',
        'Wave'
      ],
      actions: {
        button: null,
        form: {}
      },
      picture: {
        xs: '/images/jakosc-i-bezpieczenstwo-content.png',
        sm: '/images/jakosc-i-bezpieczenstwo-content.png',
        alt: 'Jakość i bezpieczeństwo'
      }
    },
    {
      subheading: 'O nas',
      heading: 'Z troską, natu.ralnie',
      text: 'Wiemy, że zdrowe i szczęśliwe życie, to zasługa holistycznego podejścia. Od najświeższej wiedzy tworzonej z naszymi ekspertami, po najlepsze jakościowo, w 100% przebadane produkty.',
      variant: [
        'Beige',
        'PictureOnLeft',
        'Wave'
      ],
      actions: {
        button: {
          label: 'Dowiedz się więcej',
          href: 'https://natu.care/pl/o-nas'
        },
        form: {}
      },
      picture: {
        xs: 'images/z-troska-naturalnie-content.png',
        sm: 'images/z-troska-naturalnie-content.png',
        alt: 'Z troską, natu.ralnie'
      }
    },
    {
      subheading: 'NEWSLETTER',
      heading: 'Odbierz 15% rabatu<br />i darmowy e-book',
      description: 'Zapisz się na nasz Newsletter i poznaj świat Natu.Care od środka! Dowiedz się jako pierwsza o nowych produktach, promocjach i ciekawostkach ze świat zdrowia.',
      variant: [
        'Beige'
      ],
      actions: {
        newsletterForm: {
          placeholder: 'Wpisz swój e-mail',
          label: 'Zapisz się',
          consent: 'Podając adres e-mail wyrażasz zgodę na otrzymywanie naszego Newslettera. Zasady świadczenia usługi Newsletter opisuje Regulamin. Klauzulę informacyjną zawiera Polityka Prywatności.',
          isSending: false,
          onSubscribe: () => { console.log('sent'); }
        }
      },
      picture: {
        xs: 'images/odbierz-15-rabatu-i-darmowy-ebook-content.png',
        sm: 'images/odbierz-15-rabatu-i-darmowy-ebook-content.png',
        alt: 'Odbierz 15% rabatu<br />i darmowy e-book'
      }
    }
  ],
  testimonialsVideo: {
    subheading: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103 21" fill="none"><path fill="#EE943F" stroke="#EE943F" stroke-linecap="round" stroke-linejoin="round" stroke-width=".476" d="M10.342 3.686c.192-.389.289-.583.419-.645a.417.417 0 0 1 .359 0c.13.062.226.256.418.645l1.822 3.692a.912.912 0 0 0 .127.217c.037.04.08.071.13.094a.91.91 0 0 0 .245.054l4.076.595c.429.063.644.095.743.2a.417.417 0 0 1 .11.34c-.018.144-.174.295-.485.598l-2.948 2.871a.911.911 0 0 0-.167.188.417.417 0 0 0-.05.152.913.913 0 0 0 .025.25l.696 4.057c.073.428.11.641.041.768a.417.417 0 0 1-.29.211c-.142.027-.334-.075-.718-.276L11.25 15.78c-.114-.06-.17-.09-.23-.101a.416.416 0 0 0-.16 0c-.06.012-.118.041-.231.101l-3.644 1.917c-.384.201-.576.303-.718.276a.417.417 0 0 1-.29-.21c-.07-.128-.033-.341.04-.77l.696-4.055c.022-.127.033-.19.026-.25a.416.416 0 0 0-.05-.153.91.91 0 0 0-.168-.188L3.574 9.476c-.31-.303-.466-.454-.485-.598a.417.417 0 0 1 .11-.34c.1-.106.315-.137.744-.2l4.076-.595c.127-.019.19-.028.245-.054a.417.417 0 0 0 .13-.094c.041-.045.07-.102.126-.217l1.822-3.692ZM30.8 3.686c.192-.389.288-.583.418-.645a.417.417 0 0 1 .359 0c.13.062.226.256.418.645l1.823 3.692c.056.115.085.172.126.217.037.04.08.071.13.094.055.026.118.035.245.054l4.076.595c.43.063.644.095.743.2a.417.417 0 0 1 .11.34c-.018.144-.173.295-.484.598l-2.949 2.871a.911.911 0 0 0-.167.188.415.415 0 0 0-.05.152.913.913 0 0 0 .026.25l.695 4.057c.073.428.11.641.041.768a.417.417 0 0 1-.29.211c-.142.027-.334-.075-.718-.276l-3.644-1.917c-.114-.06-.17-.09-.23-.101a.416.416 0 0 0-.16 0c-.06.012-.117.041-.23.101l-3.645 1.917c-.384.201-.576.303-.718.276a.417.417 0 0 1-.29-.21c-.07-.128-.032-.341.04-.77l.697-4.055a.913.913 0 0 0 .025-.25.415.415 0 0 0-.05-.153.908.908 0 0 0-.167-.188L24.03 9.476c-.31-.303-.466-.454-.485-.598a.417.417 0 0 1 .11-.34c.1-.106.315-.137.744-.2l4.076-.595c.127-.019.19-.028.245-.054a.417.417 0 0 0 .13-.094c.041-.045.07-.102.127-.217L30.8 3.686ZM51.257 3.686c.192-.389.288-.583.419-.645a.417.417 0 0 1 .358 0c.13.062.227.256.419.645l1.822 3.692a.912.912 0 0 0 .127.217c.036.04.08.071.13.094a.91.91 0 0 0 .245.054l4.076.595c.429.063.643.095.743.2a.417.417 0 0 1 .11.34c-.019.144-.174.295-.485.598l-2.948 2.871a.911.911 0 0 0-.168.188.417.417 0 0 0-.05.152.913.913 0 0 0 .026.25l.696 4.057c.073.428.11.641.04.768a.417.417 0 0 1-.29.211c-.141.027-.334-.075-.718-.276l-3.644-1.917c-.113-.06-.17-.09-.23-.101a.416.416 0 0 0-.16 0c-.06.012-.117.041-.23.101L47.9 17.697c-.384.201-.576.303-.719.276a.417.417 0 0 1-.29-.21c-.069-.128-.032-.341.041-.77l.696-4.055c.022-.127.033-.19.025-.25a.415.415 0 0 0-.05-.153.908.908 0 0 0-.167-.188L44.49 9.476c-.31-.303-.466-.454-.485-.598a.417.417 0 0 1 .11-.34c.1-.106.314-.137.744-.2l4.076-.595c.126-.019.19-.028.245-.054a.415.415 0 0 0 .13-.094c.041-.045.07-.102.126-.217l1.822-3.692ZM71.715 3.686c.192-.389.288-.583.418-.645a.417.417 0 0 1 .359 0c.13.062.226.256.418.645l1.822 3.692c.057.115.085.172.127.217.037.04.08.071.13.094.055.026.118.035.245.054l4.076.595c.43.063.644.095.743.2a.417.417 0 0 1 .11.34c-.018.144-.174.295-.484.598l-2.949 2.871a.908.908 0 0 0-.167.188.415.415 0 0 0-.05.152.913.913 0 0 0 .025.25l.696 4.057c.073.428.11.641.041.768a.417.417 0 0 1-.29.211c-.142.027-.334-.075-.718-.276l-3.644-1.917c-.114-.06-.17-.09-.23-.101a.416.416 0 0 0-.16 0c-.06.012-.117.041-.23.101l-3.645 1.917c-.384.201-.576.303-.718.276a.417.417 0 0 1-.29-.21c-.07-.128-.033-.341.04-.77l.696-4.055a.913.913 0 0 0 .026-.25.415.415 0 0 0-.05-.153.908.908 0 0 0-.168-.188l-2.948-2.871c-.31-.303-.466-.454-.485-.598a.417.417 0 0 1 .11-.34c.1-.106.315-.137.744-.2l4.076-.595c.127-.019.19-.028.245-.054a.417.417 0 0 0 .13-.094c.041-.045.07-.102.126-.217l1.823-3.692ZM92.172 3.686c.192-.389.288-.583.418-.645a.417.417 0 0 1 .359 0c.13.062.226.256.418.645l1.823 3.692c.056.115.085.172.126.217.037.04.08.071.13.094.055.026.118.035.245.054l4.076.595c.429.063.644.095.743.2a.416.416 0 0 1 .111.34c-.019.144-.174.295-.485.598l-2.948 2.871a.908.908 0 0 0-.168.188.415.415 0 0 0-.05.152c-.007.06.004.124.026.25l.695 4.057c.074.428.11.641.041.768a.417.417 0 0 1-.29.211c-.142.027-.334-.075-.718-.276L93.08 15.78c-.114-.06-.17-.09-.23-.101a.416.416 0 0 0-.16 0c-.06.012-.117.041-.23.101l-3.645 1.917c-.384.201-.576.303-.718.276a.417.417 0 0 1-.29-.21c-.07-.128-.032-.341.041-.77l.696-4.055a.913.913 0 0 0 .025-.25.417.417 0 0 0-.05-.153.911.911 0 0 0-.167-.188l-2.949-2.871c-.31-.303-.466-.454-.485-.598a.417.417 0 0 1 .111-.34c.1-.106.314-.137.743-.2l4.076-.595a.91.91 0 0 0 .246-.054.417.417 0 0 0 .13-.094.912.912 0 0 0 .126-.217l1.822-3.692Z"/></svg> <strong>4.9</strong>  (4400+ opinii)',
    heading: 'Prawdziwi ludzie, prawdziwe opinie',
    actions: {
      button: {
        label: 'Zobacz pozostałe opinie',
        href: 'https://natu.care/pl/opinie'
      }
    },
    slides: [
      {
        poster: {
          src: '/images/opinia-kasia.jpg',
          alt: 'Recenzja Kasi'
        },
        videoId: '4knyBZ-Ifpo'
      },
      {
        poster: {
          src: '/images/opinia-weronika.jpg',
          alt: 'Recenzja Weroniki'
        },
        videoId: '_b7NMYW8PHw'
      },
      {
        poster: {
          src: '/images/opinia-magda.jpg',
          alt: 'Recenzja Magdy'
        },
        videoId: 'KZEnquhZsaQ'
      },
      {
        poster: {
          src: '/images/opinia-paulina.jpg',
          alt: 'Recenzja Pauliny'
        },
        videoId: 'tKTqle1xgHA'
      },
      {
        poster: {
          src: '/images/opinia-kamila.jpg',
          alt: 'Recenzja Kamili'
        },
        videoId: '_j4IiUPxH_k'
      },
      {
        poster: {
          src: '/images/opinia-iza.jpg',
          alt: 'Recenzja Izy'
        },
        videoId: 'pslEPkx_Ro8'
      },
      {
        poster: {
          src: '/images/opinia-ewa.jpg',
          alt: 'Recenzja Ewa'
        },
        videoId: 'gJX2gh50_6o'
      },
      {
        poster: {
          src: '/images/opinia-janek.jpg',
          alt: 'Recenzja Janek'
        },
        videoId: 'hlMoqBKsxg'
      }
    ]
  },
  reviewsWeb: {
    heading: 'Opinie po 85000+ zamówieniach',
    text: 'Odkryj, za co pokochały nas tysiące kobiet - takich jak Ty! Czy wiesz, że ponad 80% z osób, które dokonały u nas pierwszego zakupu, pozostało naszymi stałymi klientkami? ',
    items: [
      {
        rate: '<strong>4.9</strong>/5',
        icon: {
          path: '<g clip-path="url(#googleA)"><path fill="#EA4335" d="M40.958 16.445c0 4.441-3.475 7.714-7.74 7.714-4.264 0-7.739-3.273-7.739-7.714 0-4.473 3.475-7.715 7.74-7.715 4.264 0 7.739 3.242 7.739 7.715Zm-3.388 0c0-2.776-2.014-4.675-4.352-4.675-2.337 0-4.35 1.899-4.35 4.675 0 2.747 2.013 4.674 4.35 4.674 2.338 0 4.352-1.93 4.352-4.674Z"/><path fill="#FBBC05" d="M57.654 16.445c0 4.441-3.474 7.714-7.739 7.714-4.264 0-7.739-3.273-7.739-7.714 0-4.47 3.475-7.715 7.74-7.715 4.264 0 7.739 3.242 7.739 7.715Zm-3.387 0c0-2.776-2.014-4.675-4.352-4.675-2.337 0-4.35 1.899-4.35 4.675 0 2.747 2.013 4.674 4.35 4.674 2.338 0 4.352-1.93 4.352-4.674Z"/><path fill="#4285F4" d="M73.652 9.196v13.85c0 5.698-3.36 8.025-7.332 8.025-3.74 0-5.99-2.501-6.839-4.546l2.95-1.228c.525 1.255 1.812 2.737 3.885 2.737 2.543 0 4.118-1.569 4.118-4.521v-1.11h-.118c-.758.936-2.22 1.753-4.063 1.753-3.857 0-7.39-3.36-7.39-7.683 0-4.355 3.533-7.743 7.39-7.743 1.84 0 3.301.817 4.063 1.725h.118V9.2h3.218v-.003Zm-2.978 7.277c0-2.717-1.812-4.703-4.118-4.703-2.337 0-4.296 1.986-4.296 4.703 0 2.688 1.959 4.646 4.296 4.646 2.306 0 4.118-1.958 4.118-4.646Z"/><path fill="#34A853" d="M78.957 1.078v22.608h-3.304V1.078h3.304Z"/><path fill="#EA4335" d="m91.835 18.984 2.63 1.753c-.849 1.256-2.894 3.419-6.428 3.419-4.382 0-7.655-3.388-7.655-7.715 0-4.588 3.3-7.715 7.276-7.715 4.004 0 5.962 3.186 6.602 4.908l.351.877-10.313 4.271c.79 1.548 2.017 2.337 3.74 2.337 1.725 0 2.921-.848 3.797-2.135Zm-8.093-2.776 6.893-2.862c-.379-.964-1.52-1.635-2.862-1.635-1.722 0-4.118 1.52-4.031 4.497Z"/><path fill="#4285F4" d="M12.97 14.438v-3.273H24c.108.57.164 1.245.164 1.975 0 2.456-.672 5.492-2.835 7.656-2.105 2.191-4.793 3.36-8.355 3.36-6.602 0-12.153-5.377-12.153-11.98C.821 5.577 6.372.199 12.974.199c3.652 0 6.254 1.433 8.209 3.3l-2.31 2.31c-1.402-1.315-3.3-2.337-5.902-2.337-4.821 0-8.592 3.885-8.592 8.706 0 4.82 3.77 8.706 8.592 8.706 3.127 0 4.907-1.256 6.048-2.397.926-.925 1.534-2.247 1.774-4.052l-7.822.004Z"/></g><defs><clipPath id="googleA"><path fill="#fff" d="M.696.034h94.609v32H.695z"/></clipPath></defs>',
          viewBox: '0 0 96 33'
        }
      },
      {
        rate: '<strong>4.94</strong>/5',
        icon: {
          path: '<path fill="url(#reviewswebb)" d="M0 .81h142.298v32H0z"/> <defs> <pattern id="reviewswebb" width="1" height="1" patternContentUnits="objectBoundingBox"> <use xlink:href="#reviewswebc" transform="scale(.00478 .02128)"/> </pattern> <image xlink:href="data:image/png;base64,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" id="reviewswebc" width="209" height="47"/> </defs>',
          viewBox: '0 0 143 33'
        }
      },
      {
        rate: '<strong>4400+</strong>',
        text: 'Ilość zebranych opinie na&nbsp;nasz temat'
      },
      {
        rate: '<strong>90%</strong>',
        text: 'Wynik w Net Promoter Score'
      }
    ]
  },
  mediaSocial: {
    heading: 'Odkryj nasze social media',
    items: [
      {
        picture: {
          xs: 'images/media-social-1.jpg',
          alt: 'Odkryj nasze social media'
        }
      },
      {
        picture: {
          xs: 'images/media-social-2.jpg',
          alt: 'Odkryj nasze social media'
        }
      },
      {
        picture: {
          xs: 'images/media-social-3.jpg',
          alt: 'Odkryj nasze social media'
        }
      },
      {
        picture: {
          xs: 'images/media-social-4.jpg',
          alt: 'Odkryj nasze social media'
        }
      }
    ],
    socials: [
      {
        icon: {
          path: '<path fill="currentColor" d="m19.4207 16.6961.3898-2.5615h-2.478V12.464c0-.7239.3341-1.3921 1.4478-1.3921h1.1416V8.8723s-1.0302-.1949-2.0047-.1949c-2.0325 0-3.369 1.253-3.369 3.4804v1.9768h-2.2831v2.5615h2.2831v6.2368h2.7843v-6.2368h2.0882Z"></path>',
          viewBox: '0 0 32 32'
        },
        label: 'Facebook',
        href: 'https://www.facebook.com/profile.php?id=100083714082839'
      },
      {
        icon: {
          path: '<path fill="currentColor" d="M16.5836 12.308c-1.9512 0-3.5061 1.5854-3.5061 3.5061 0 1.9513 1.5549 3.5062 3.5061 3.5062 1.9208 0 3.5062-1.5549 3.5062-3.5062 0-1.9207-1.5854-3.5061-3.5062-3.5061Zm0 5.7928c-1.25 0-2.2866-1.0062-2.2866-2.2867 0-1.25 1.0061-2.2561 2.2866-2.2561a2.251 2.251 0 0 1 2.2562 2.2561c0 1.2805-1.0061 2.2867-2.2562 2.2867Zm4.4513-5.9148a.8198.8198 0 0 0-.8232-.8232.8197.8197 0 0 0-.8231.8232c0 .4573.3658.8232.8231.8232a.8198.8198 0 0 0 .8232-.8232Zm2.3171.8232c-.0609-1.0976-.3049-2.0732-1.0975-2.8659-.7927-.7927-1.7684-1.0366-2.8659-1.0976-1.1281-.061-4.5123-.061-5.6404 0-1.0976.061-2.0427.305-2.8659 1.0976-.7927.7927-1.0366 1.7683-1.0976 2.8659-.061 1.1281-.061 4.5123 0 5.6403.061 1.0976.3049 2.0428 1.0976 2.8659.8232.7927 1.7683 1.0366 2.8659 1.0976 1.1281.061 4.5123.061 5.6404 0 1.0975-.061 2.0732-.3049 2.8659-1.0976.7926-.8231 1.0366-1.7683 1.0975-2.8659.061-1.128.061-4.5122 0-5.6403Zm-1.4634 6.8294c-.2134.6097-.7012 1.0671-1.2805 1.311-.9147.3658-3.0488.2744-4.0245.2744-1.0061 0-3.1403.0914-4.0244-.2744-.6098-.2439-1.0671-.7013-1.311-1.311-.3659-.8842-.2744-3.0184-.2744-4.0245 0-.9756-.0915-3.1098.2744-4.0244.2439-.5793.7012-1.0366 1.311-1.2805.8841-.3659 3.0183-.2744 4.0244-.2744.9757 0 3.1098-.0915 4.0245.2744.5793.2134 1.0366.7012 1.2805 1.2805.3659.9146.2744 3.0488.2744 4.0244 0 1.0061.0915 3.1403-.2744 4.0245Z"></path>',
          viewBox: '0 0 32 32'
        },
        label: 'Instagram',
        href: 'https://www.instagram.com/natucare_pl/'
      },
      {
        icon: {
          path: '<path fill="currentColor" d="M21.2714 11.3565c-.7804-.5003-1.3437-1.3007-1.5195-2.2338a3.3592 3.3592 0 0 1-.0588-.6214h-2.4909l-.004 9.8143c-.0419 1.099-.962 1.9811-2.0899 1.9811a2.1085 2.1085 0 0 1-.9713-.2365c-.6665-.3449-1.1226-1.0317-1.1226-1.822 0-1.1352.9394-2.0587 2.0939-2.0587.2155 0 .4222.035.6178.0952v-2.5c-.2024-.0271-.408-.044-.6178-.044-2.5282 0-4.5849 2.022-4.5849 4.5075 0 1.5249.775 2.8744 1.9573 3.6904a4.6123 4.6123 0 0 0 2.6276.817c2.5281 0 4.5848-2.022 4.5848-4.5074v-4.9767c.977.6894 2.174 1.0956 3.4656 1.0956v-2.4489a3.4868 3.4868 0 0 1-1.8873-.5517Z"></path>',
          viewBox: '0 0 32 32'
        },
        label: 'TikTok',
        href: 'https://www.tiktok.com/@natucare_pl'
      },
      {
        icon: {
          path: '<path stroke="currentColor" d="M23.113 12.6249h.0001c-.1268-.4437-.4315-.7504-.8735-.8793-.215-.0523-.6434-.0991-1.2076-.1359-.5568-.0363-1.2058-.0607-1.8263-.0771a99.4839 99.4839 0 0 0-2.1576-.0321l-.1424-.0004-.037-.0001h-.0123l-.0001-.5v.5h-.0121l-.0363.0001-.1397.0004a97.7017 97.7017 0 0 0-2.1283.0321c-.615.0164-1.2614.0408-1.8225.0771-.5628.0364-1.0058.083-1.2485.1371-.4302.1269-.7297.4225-.8608.8494-.0791.5357-.1212 1.3423-.1426 2.0395a49.1685 49.1685 0 0 0-.0213 1.167l-.0003.0727v.0187l-.0001.0046v.0025l.0001.0044v.0183l.0004.0721a31.8955 31.8955 0 0 0 .0318 1.1606c.0326.7056.0964 1.5101.2145 2.0304.1288.4373.4319.7396.87.8674.215.0523.6434.0991 1.2076.1359.5568.0363 1.2058.0607 1.8263.0771a99.4839 99.4839 0 0 0 2.1576.0321l.1423.0004.0371.0001H16.9438v.5l.0001-.5h.0121l.0363-.0001.1397-.0004a97.7017 97.7017 0 0 0 2.1283-.0321c.615-.0164 1.2614-.0408 1.8225-.0771.5628-.0364 1.0058-.083 1.2485-.1371.4358-.1285.7375-.4303.8658-.8662.1181-.5203.1819-1.3248.2145-2.0304a31.8955 31.8955 0 0 0 .0318-1.1606l.0004-.0721V15.9002l-.3308-3.2753Zm0 0 .003.0096c.1557.5061.2413 1.3056.285 2.0165a23.7311 23.7311 0 0 1 .0422 1.1543l.0006.0714V15.9l-.3308-3.2751Z"></path><path fill="currentColor" stroke="currentColor" d="M16.4438 17.3384v-2.4768L18.6111 16.1l-2.1673 1.2384Z"></path>',
          viewBox: '0 0 32 32'
        },
        label: 'Youtube',
        href: 'https://www.youtube.com/channel/UCio8DcT_TAZDlruVG4HOl9g'
      },
      {
        icon: {
          path: '<path fill="currentColor" fill-rule="evenodd" d="M15.0337 18.7034h2.2759v5.1151h-2.2759v-5.1151Z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M9.7716 13.467h3.8674l-2.7535-2.6062 1.5173-1.5462 2.6197 2.6794V8.1815h2.2759v3.8115l2.6187-2.6793 1.5173 1.5461-2.7535 2.6062h3.8684v2.1556h-3.8924l2.766 2.6794-1.5173 1.5105-3.7577-3.7634-3.7576 3.7634-1.5173-1.5105 2.766-2.6794H9.7476V13.467h.024Z" clip-rule="evenodd"></path>',
          viewBox: '0 0 32 32'
        },
        label: 'Linktree',
        href: 'https://linktr.ee/natu.care'
      },
    ],
    cta: {
      heading: 'Grupa na Facebooku',
      text: 'Dołącz do grupy kobiet, takich jak Ty! Zadaj nurtujące Cię pytania, testuj nasze nowe produkty i poznaj ciekawostki ze świata zdrowia.',
      actions: {
        button: {
          label: 'Dołącz do nas',
          href: 'https://www.facebook.com/groups/1052438712546453/'
        }
      }
    }
  }
};
